import axios from 'axios'

class VATService {
  static checkVAT (VATinfo) {
    return axios.post('api/vat', VATinfo)
  }
};

export default VATService
